import React from 'react';
import {AssetTypeFormProps} from '../interfaces';
import {
  AssetSizeSelect,
  TrailerNumberField,
  DriverFields,
  ScacCodeField,
  TruckLicensePlateField,
  NotesField,
} from '../fields';

/**
 * Check-in form for Trailer Empty asset types.
 * Covers: TRUCK_TRAILER_EMPTY, TRAILER_EMPTY.
 *
 * Required fields: Asset Size, Trailer Number, Driver First Name, Driver Last Name.
 * Optional fields: Driver License Number (rendered but not required).
 */
const TrailerEmptyForm: React.FC<AssetTypeFormProps> = ({form, errors, onValueChange, onAssetSizeChange}) => {
  return (
    <>
      <AssetSizeSelect
        value={form.assetSize}
        onChange={onAssetSizeChange}
        required
      />
      <TrailerNumberField
        value={form.trailerNumber}
        onValueChange={onValueChange}
        error={errors.trailerNumber}
        required
      />
      <DriverFields
        form={form}
        errors={errors}
        onValueChange={onValueChange}
        requireLicense={false}
      />
      <ScacCodeField
        value={form.scacCode}
        onValueChange={onValueChange}
        error={errors.scacCode}
      />
      <TruckLicensePlateField
        value={form.truckLicensePlateNumber}
        onValueChange={onValueChange}
        error={errors.truckLicensePlateNumber}
      />
      <NotesField
        value={form.notes}
        onValueChange={onValueChange}
      />
    </>
  );
};

export default TrailerEmptyForm;

